module.exports = __webpack_public_path__ + "img/9.11af7029.jpg";